import { Dispatch, useEffect, useLayoutEffect } from "react"

import type { PlaidDataActionType } from "../../../Helpers/Reducers/PlaidData/types"
import { postMessageSender } from "../../../Helpers/PostMessage"
import "./style.css"
import { usePlaidLink } from "react-plaid-link"

type PlaidProps = {
  token: string
  onEvent: Dispatch<PlaidDataActionType>
  onSuccess: (data: { linkSessionId: string; institutionId: string; publicToken: string }, bankInstitution: string) => void
  onExit: () => void
}

export function Plaid(props: PlaidProps) {
  const { open, ready } = usePlaidLink({
    token: props.token,
    onEvent: (eventName, message) => {
      if (eventName === 'SUBMIT_CREDENTIALS') {
        postMessageSender({
          event: "marketing",
          payload: {
            status: "track",
            data: {
              event: "app_banking_plaid_submitted",
              skipCleverTap: true,
              properties: {
                bankInstitution: message.institution_name,
              },
            },
          },
        })
      }
      props.onEvent({
        type: "ADD_EVENT",
        payload: {
          event: {
            eventName: eventName,
            linkSessionId: message.link_session_id,
            viewName: message.view_name ?? "",
            timestamp: message.timestamp,
          },
          raw: message,
        },
      })
    },
    onExit: (error, message) => {
      if (error) {
        props.onEvent({
          type: "ADD_EVENT",
          payload: {
            event: {
              eventName: "ERROR",
              linkSessionId: message.link_session_id,
              viewName: "",
              timestamp: new Date().toISOString(),
            },
            raw: message,
          },
        })
      }
      props.onExit()
    },
    onLoad: () => {},
    onSuccess: (token, message) => {
      props.onEvent({
        type: "ADD_EVENT",
        payload: {
          event: {
            eventName: "SUCCESS",
            linkSessionId: message.link_session_id,
            viewName: "",
            timestamp: new Date().toISOString(),
          },
          raw: { ...message, publicToken: token },
        },
      })

      props.onSuccess({
        linkSessionId: message.link_session_id ?? "",
        institutionId: message.institution?.institution_id ?? "",
        publicToken: token,
      }, message.institution?.name ?? '')
    },
  })

  // init iframe
  useLayoutEffect(() => {
    if (!ready) return

    open()

    document.body?.style.setProperty("overflow", "auto", "important")

    let plaidLinkRoot = document.getElementById("root")
    let plaidContainer = document.getElementById("plaid-container")
    let plaidIframe = document.getElementsByTagName("iframe")[0]
    plaidContainer?.appendChild(plaidIframe)

    if (plaidLinkRoot) {
      plaidLinkRoot.style.setProperty("display", "block", "important")
      // When application come from mobile, there is a display: none !important set by react-plaid-link. We reset to display: block.
    }
  }, [ready])

  return <div id="plaid-container" className="h-[650px] sm:h-auto" />
}
